import { useInfiniteQuery } from 'react-query'

import { api } from 'utils/api'

import type { CommonResponse } from 'types/api'
import type { BuktiKaryaDocumentResponse } from 'types/bukti-karya'

const basePath = '/teachers-career/v1alpha1/document'

export function useAPIGetDocumentsByCategories(category: string) {
  return useInfiniteQuery(
    [`${basePath}/document/pdf/category`, category],
    async ({ pageParam = 1 }) => {
      const response = await api<CommonResponse<BuktiKaryaDocumentResponse[]>>(
        `${basePath}/pdf/category/${category}?page=${pageParam}&pageSize=6`
      )
      return response
    },
    {
      getNextPageParam: (lastPage) => {
        const { offset, limit, total } = lastPage.meta
        const nextOffset = offset + limit
        if (nextOffset < total) return nextOffset
      },
    }
  )
}
